module.exports = __webpack_public_path__ + "img/projects.8f9eee1e.png";